// Copyright (c) Docugami, Inc. All rights reserved.

import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { Config } from "config";
import { createDgBaseQuery } from "store/baseQuery";
import { SpanId, SpanIdUtils } from "utils/SpanIdUtils";

export interface ExpandRepeatsRequest {
    docsetId: string;
    fileId: string;
    positiveSpans: string[];
    negativeSpans: string[];
    anchorSpans?: string[];
}

interface NetworkExpandRepeatsResponse {
    results: string[];
}

export interface ExpandRepeatsResponse {
    results: SpanId[];
}

const baseQuery = createDgBaseQuery(`${Config.repeatsUrl}`);
export const repeatsSlice = createApi({
    reducerPath: 'repeats',
    baseQuery: baseQuery,
    endpoints: builder => ({
        expand: builder.mutation<ExpandRepeatsResponse, ExpandRepeatsRequest>({
            query: (request) => ({
                url: '/expand',
                method: 'POST',
                body: request
            }),
            transformResponse: (response: NetworkExpandRepeatsResponse, meta, request): ExpandRepeatsResponse => ({
                results: response.results.map(r => SpanIdUtils.parse(r))
            })
        })
    })
});

export const { useExpandMutation } = repeatsSlice;
